/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getMaintenance = /* GraphQL */ `query GetMaintenance($id: ID!) {
  getMaintenance(id: $id) {
    id
    maintenance
    env
    dateTime
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMaintenanceQueryVariables,
  APITypes.GetMaintenanceQuery
>;
export const listMaintenances = /* GraphQL */ `query ListMaintenances(
  $filter: TableMaintenanceFilterInput
  $limit: Int
  $nextToken: String
) {
  listMaintenances(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      maintenance
      env
      dateTime
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMaintenancesQueryVariables,
  APITypes.ListMaintenancesQuery
>;
